import { __decorate } from "tslib";
import { Component, Vue } from "../../../vue";
import { Switch } from 'ant-design-vue';
import { IMethodEditorState } from "../MethodEditorState";
import styles from "./style.module.css";
import LabelSwitch from "./LabelSwitch";
let MethodSettings = class MethodSettings extends Vue {
  constructor() {
    // _tsx:DeclareProps<Pick<MethodSettings,''>>
    super(...arguments);
    this.isShow = false;
  }
  get method() {
    return this.state.method;
  }
  get hasArg() {
    var _this$state$method;
    return Boolean((_this$state$method = this.state.method) === null || _this$state$method === void 0 || (_this$state$method = _this$state$method.args) === null || _this$state$method === void 0 ? void 0 : _this$state$method.length);
  }
  render() {
    const h = arguments[0];
    if (!this.method) return null;
    return h("div", {
      "class": styles.settings
    }, [h(LabelSwitch, {
      "attrs": {
        "title": "高级设置"
      },
      "model": {
        value: this.isShow,
        callback: $$v => {
          this.isShow = $$v;
        }
      }
    }), this.isShow && this.renderContent()]);
  }
  renderContent() {
    var _this$state$method2;
    const h = this.$createElement;
    const fields = [{
      id: 'autoCatch',
      label: '捕抓错误并提示',
      Comp: Switch
    }, {
      id: 'loading',
      label: '使用loading状态',
      Comp: Switch
    }];
    const showCodeArgs = this.hasArg && !this.state.isForm;
    return h("div", [h("a-form-model", {
      "attrs": {
        "labelAlign": "left",
        "layout": "horizontal",
        "labelCol": {
          span: 6
        },
        "wrapperCol": {
          span: 14
        }
      }
    }, [fields.map(item => {
      const {
        id,
        label,
        Comp
      } = item;
      return h("a-form-item", {
        "attrs": {
          "label": label
        }
      }, [h(Comp, {
        "model": {
          value: this.method[id],
          callback: $$v => {
            this.$set(this.method, id, $$v);
          }
        }
      })]);
    })]), showCodeArgs ? h("a-divider") : null, showCodeArgs ? h(MethodArgsForm) : null, h("a-divider"), h("a-button", {
      "attrs": {
        "type": "primary",
        "icon": "delete",
        "disabled": (_this$state$method2 = this.state.method) === null || _this$state$method2 === void 0 ? void 0 : _this$state$method2.system
      },
      "on": {
        "click": () => this.state.onDelete()
      }
    }, ["\u5220\u9664\u8BE5\u65B9\u6CD5"])]);
  }
};
__decorate([IMethodEditorState], MethodSettings.prototype, "state", void 0);
MethodSettings = __decorate([Component({
  name: 'MethodSettings'
})], MethodSettings);
export default MethodSettings;
let MethodArgsForm = class MethodArgsForm extends Vue {
  get columns() {
    const h = this.$createElement;
    return [{
      title: '',
      key: 'index',
      customRender: (_text, _record, index) => `参数${index + 1}`
    }, {
      title: '参数id',
      key: 'id',
      dataIndex: 'id'
    }, {
      title: '参数标题',
      key: 'title',
      dataIndex: 'title',
      customRender: (_text, arg) => h("a-input", {
        "model": {
          value: arg.title,
          callback: $$v => {
            this.$set(arg, "title", $$v);
          }
        }
      })
    }];
  }
  render() {
    var _this$state$method3;
    const h = arguments[0];
    const rowKey = (record, index) => `${record.id}_${index}`;
    return h("a-table", {
      "attrs": {
        "rowKey": rowKey,
        "pagination": false,
        "columns": this.columns,
        "dataSource": (_this$state$method3 = this.state.method) === null || _this$state$method3 === void 0 ? void 0 : _this$state$method3.args
      }
    });
  }
};
__decorate([IMethodEditorState], MethodArgsForm.prototype, "state", void 0);
MethodArgsForm = __decorate([Component({
  name: 'MethodArgsForm'
})], MethodArgsForm);
//# sourceMappingURL=MethodSettings.js.map
